// all game entities (other than the player) such as characters, etc. can be declared here
export const CHARACTERS = {
  testCharacter: {
    prototypeId: 'testCharacter',
    name: 'Test Character',
    spriteId: 'testCharacter'
  },
  isabelle: {
    prototypeId: 'isabelle',
    name: 'Isabelle Carter',
    spriteId: 'isabelle'
  },
  daniel: {
    prototypeId: 'daniel',
    name: 'Daniel Whitmore',
    spriteId: 'daniel'
  },
  emily: {
    prototypeId: 'emily',
    name: 'Emily Sterling',
    spriteId: 'emily'
  },
  emilysMother: {
    prototypeId: 'emilysMother',
    name: 'Emily\'s Mother',
    spriteId: 'emilysMother'
  },
  minister: {
    prototypeId: 'minister',
    name: 'Minister',
    spriteId: 'minister'
  },
  assistant: {
    prototypeId: 'assistant',
    name: 'Isabelle\'s Assistant',
    spriteId: 'assistant'
  },
  client: {
    prototypeId: 'client',
    name: 'Client',
    spriteId: 'client'
  }
}

export const LOCATIONS = {
  weddingVenue: {
    name: 'Wedding Venue',
    spriteId: 'weddingVenue'
  },
  bridalSuite: {
    name: 'Bridal Suite',
    spriteId: 'bridalSuite'
  },
  gardenTerrace: {
    name: 'Garden Terrace',
    spriteId: 'gardenTerrace'
  },
  rehearsalDinner: {
    name: 'Rehearsal Dinner',
    spriteId: 'rehearsalDinner'
  },
  newApartment: {
    name: 'New Apartment',
    spriteId: 'newApartment'
  },
  familyGarden: {
    name: 'Family Garden',
    spriteId: 'familyGarden'
  },
  isabellesOffice: {
    name: 'Isabelle\'s Office',
    spriteId: 'isabellesOffice'
  }
}
